import axios from "axios";
import { API_URL } from "../Config/environment"

export async function getAllArticles() {
  const resp = await axios.get(`${API_URL}/health-articles/home-page?page=1&limit=6`);
  return resp?.data?.data  ?? [];
}

export async function getArticleById(article_id) {
  try {
    const resp = await axios.get(`${API_URL}/health-articles/home-page/${article_id}`);

     return resp?.data?.data ?? null;
  } catch (error) {
    console.error("Error fetching Article by ID:", error);
    throw error;
  }
}
